import { Button } from './primitives/Button.js';
import { Container } from './primitives/Misc.js';
import type { CurrencyCode } from '../hooks/useCurrency.js';
import './FinalCta.css';

export interface FinalCtaProps {
  ccyCode: CurrencyCode;
  onOpenAudit: () => void;
  onWatchVideo: () => void;
}

export function FinalCta({ ccyCode, onOpenAudit, onWatchVideo }: FinalCtaProps) {
  return (
    <Container className="land-section land-final-cta-wrap">
      <div className="land-final-cta">
        <div className="land-final-cta__copy">
          <h2>Start with one cluster. Decide if you trust us.</h2>
          <p>
            Connect two systems read-only, get the findings report with {ccyCode} figures
            attached, and change nothing unless you say so.
          </p>
        </div>
        <div className="land-final-cta__actions">
          <Button variant="inverse" size="lg" onClick={onOpenAudit}>
            Run a free data audit
          </Button>
          <Button variant="outline-on-dark" size="lg" onClick={onWatchVideo}>
            Watch the review
          </Button>
        </div>
      </div>
    </Container>
  );
}
